/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FilterMixin from 'app/mixins/FilterMixin.js';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import Loading from 'app/components/common/Loading.jsx';
import FeatureUpgradeComponent from 'app/components/Subscription/FeatureUpgradeComponent.jsx';
import Content from 'app/components/common/Content.jsx';
import SearchControl from 'app/components/common/SearchControl.jsx';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import { Breakpoint } from 'react-socks';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class Connections extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            creating: false,
            connections: [],
            filtered: false,
            filteredConnections: [],
            error: null,
            isReconnecting: false
        };

        this.searchHandler = this.searchHandler.bind(this);
        this.createConnection = this.createConnection.bind(this);
        this.reconnectConnection = this.reconnectConnection.bind(this);
        this.removeConnection = this.removeConnection.bind(this);
        this.startSearch = this.startSearch.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            errors = [];

        errors = props.getApiErrors(['CONNECTION_CREATE']);
        if (errors.length && state.error === null) {
            let error = errors[0],
                message = (error.error.perms !== undefined && error.errors.perms.code !== undefined) ? "You've used all " + props.user.perms.resources.connectionLimit + " of your WordPress connections"  : "An error occurred and we couldn't create your connection.",
                confirm = () => {
                    props.closeAllModals(null);
                },
                modal = null;

            modal = (
                <ConfirmModal
                    showCancel={false}
                    modalCopy={message}
                    confirmAction={confirm}
                    confirmLabel={'OK'} />
            );

            props.addModal(modal);

            nextState.creating = false;
            nextState.error = errors[0];
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {

        if (this.props.router.query !== null && this.props.router.query.state && this.props.router.query.state.match(/GENERIC/)) {
            this.props.authReturnHandler({path: '/content/connections'}, () => {
                this.props.createConnection();
                this.props.resetAuthState()
            });
        }

        this.props.getConnections();

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.connections.length != this.props.connections.length && prevState.creating) {
            this.setState({
                creating: false,
            })
        }

    }

    searchHandler(e, search) {

        var filtered = this.state.filtered,
            filteredConnections = [];

        if (search === '') {
            filtered = false;
        } else {
            filtered = true;
            filteredConnections = FilterMixin.filterCollection.apply(this, [this.props.connections, 'name', search]);
        }

        this.setState({
            filtered: filtered,
            filteredConnections
        });

    }

    createConnection(e) {

        ConnectMixin.connectService.apply(this, [e]);

    }

    reconnectConnection(e) {
        var serviceId = e.currentTarget.dataset.serviceid,
            gaId = e.currentTarget.dataset.id,
			url = "/remote/beginreauth?gsID=:gsId&gaID=:gaId&state=:state&final=:final",
			date = new Date(),
			state = ['REAUTHGENERIC', serviceId, gaId, date.getTime()].join("_"),
			constants = this.props.app.config.constants;

        e.preventDefault();
        e.stopPropagation();

        if (this.state.isReconnecting) {
            return;
        }

        this.setState({
            isReconnecting: true
        }, () => {
            url = url.replace(':gsId', serviceId);
    		url = url.replace(':gaId', gaId);
    		url = url.replace(':state', state);
    		url = url.replace(':final', window.encodeURIComponent(window.location.href));
    		window.location.assign(url);
        });

    }

    removeConnection(e) {
        let id = e.currentTarget.dataset.id,
            modal = null,
            confirm = () => {
                this.props.closeAllModals(null);
                this.props.deleteConnection(id);
            },
            cancel = () => {
                this.props.closeAllModals(null);
            };

        e.preventDefault();
        e.stopPropagation();

        if (id) {
            modal = (
                <ConfirmModal
                    modalCopy={"Are you sure you want to remove this connection?"}
                    cancelAction={cancel}
                    confirmAction={confirm}/>

            );
            this.props.addModal(modal)
        }

    }

    startSearch(e) {
        let id = e.currentTarget.dataset.id;

        e.preventDefault();
        e.stopPropagation();

        if (id) {
            this.props.router.navigate("/content/import/wordpress/" + id);
        }

    }

    render() {
        let content = null,
            modal = this.state.modal,
            main = null,
            constants = this.props.app.config.constants,
            connections = (this.state.filtered) ? this.state.filteredConnections : this.props.connections,
            loading = (<Loading/>);

        if (this.props.app.loading.CONNECTION_LIST || this.state.creating) {
            return (
                <Content main={loading}/>
            );
        }

        if (this.props.user.perms.resources && !this.props.user.perms.resources.genericAccts) {
            content = (
                <FeatureUpgradeComponent
                    {...this.props}
                    context="importConnections"/>
            );
            return (
                <Content main={content}/>
            );
        }

        if (!this.props.app.loading.CONNECTION_LIST && this.props.connections.length === 0) {
            main = (
                <div className="loading">
                    <h3>
                        <a href="#" onClick={this.createConnection} data-servicetype="gsID" data-serviceid={constants.GENERIC_SVC_WORDPRESS}><i className="icon ion-social-wordpress wp-inline"></i>Connect a WordPress Blog</a> to import and schedule posts
                    </h3>
                    <h4>
                        <a href="https://support.dlvrit.com/hc/en-us/articles/360000509414-How-do-I-use-Jetpack-in-my-WordPress-account-" target="_blank">Learn how to connect to WordPress from dlvr.it</a>
                    </h4>
                </div>
            );
        } else {
            main = (
                <ul className="dlvr-list-component">
                    {connections.map((connection) => {
                        let status = (<i className="fa fa-check-circle"></i>),
                            inactive = false,
                            statusClass = "item-row-cell status connection active",
                            itemClass = 'dlvr-list-item connection',
                            connectionError = null;

                        if (parseInt(connection.activeFlag) === 0 && parseInt(connection.sysActionFlag) === 1) {
                            inactive = true;
                            status = (<i className="fa fa-minus-circle"></i>);
                            statusClass = statusClass.replace('active', 'inactive');
                            itemClass += ' connection-error';
                            connectionError = (
                                <div className="item-error">
                                    <i className="icon ion-information-circled"></i>The credentials for this connection are out of date. <a href="#" onClick={this.reconnectConnection} data-serviceid={connection.gsID} data-id={connection.id}>Reconnect it now.</a>
                                </div>
                            )
                        }

                        return (
                            <li key={connection.id} className={itemClass}>
                                <Breakpoint desktop only>
                                    <div className="list-item-row no-detail" onClick={this.startSearch} data-id={connection.id}>
                                        <div className="item-row-cell input-label connections">
                                            <div className="item-icon-wrapper">
                                                <SocialAvatar
                                                    social={connection}
                                                    compact={true}
                                                    showCompactName={false} />
                                            </div>
                                            <div className="item-input-label">
                                                {connection.name}
                                            </div>
                                        </div>
                                        <div className={statusClass}>
                                            <div className="item-control search" alt="Search This Blog" title="Search This Blog" onClick={this.startSearch} data-id={connection.id} role="button" aria-label="Search this blog">
                                                <i className="fa fa-search"></i> Search This Blog
                                            </div>
                                            <div className="item-control" alt="Reconnect" title="Reconnect" onClick={this.reconnectConnection} data-serviceid={connection.gsID} data-id={connection.id} role="button" aria-label="Reconnect">
                                                <i className="fa fa-refresh"></i>
                                            </div>
                                            <div className="item-control" alt="Reconnect" title="Remove" onClick={this.removeConnection} data-serviceid={connection.gsID} data-id={connection.id} role="button" aria-label="Remove connection">
                                                <i className="fa fa-trash-o"></i>
                                            </div>
                                            <span className="item-status-icon">
                          						{status}
                          					</span>
                                        </div>
                                    </div>
                                </Breakpoint>
                                <Breakpoint mobile only>
                                    <div className="list-item-row no-detail" onClick={this.startSearch} data-id={connection.id}>
                                        <div className="item-row-cell input-label connections">
                                            <div className="item-icon-wrapper">
                                                <SocialAvatar
                                                    social={connection}
                                                    compact={true}
                                                    showCompactName={false} />
                                            </div>
                                            <div className="item-input-label">
                                                {connection.name}
                                            </div>
                                        </div>
                                        <div className={statusClass}>
                                            <div className="item-control search" alt="Search This Blog" title="Search This Blog" onClick={this.startSearch} data-id={connection.id} role="button" aria-label="Search this blog">
                                                <i className="fa fa-search"></i>
                                            </div>
                                            <div className="item-control" alt="Reconnect" title="Reconnect" onClick={this.reconnectConnection} data-serviceid={connection.gsID} data-id={connection.id} role="button" aria-label="Reconnect">
                                                <i className="fa fa-refresh"></i>
                                            </div>
                                            <div className="item-control" alt="Remove" title="Remove" onClick={this.removeConnection} data-serviceid={connection.gsID} data-id={connection.id} role="button" aria-label="Remove connection">
                                                <i className="fa fa-trash-o"></i>
                                            </div>
                                            <span className="item-status-icon">
                          						{status}
                          					</span>
                                        </div>
                                    </div>
                                </Breakpoint>
                                {connectionError}
                            </li>
                        );
                    })}
                </ul>
            );
        }

        content = (
            <div>
                <div className="content-header">
                    <Breakpoint desktop only>
                        <div className="control-bar">
                            <div className="control search">
                                <SearchControl
                                    {...this.props}
                                    changeHandler={this.searchHandler}
                        			extraClasses=""
                        			placeholder="Search Connections"
                        			wrapperClass="header-control"
                                    defaultFocus={false}/>
                            </div>
                            <div className="control connect wp">
                                <div className="control-wrapper" onClick={this.createConnection} data-servicetype="gsID" data-serviceid={constants.GENERIC_SVC_WORDPRESS} role="button" aria-label="Add WP Connection">
                                    <span className="va-helper"></span>
                					<div className="control-icon">
                						<i className="fa fa-plus-square new-icon"></i>
                					</div>
                					<div className="control-label">Add WP Connection</div>
                                </div>
                            </div>
                        </div>
                    </Breakpoint>
                    <Breakpoint mobile only>
                        <div className="mobile-control-bar">
                            <div className="control new connection" onClick={this.createConnection} data-servicetype="gsID" data-serviceid={constants.GENERIC_SVC_WORDPRESS} role="button" aria-label="Add WP Connection">
    							<span className="va-helper"></span>
    							<i className="fa fa-plus-square new-icon"></i> Add WP Connection
    						</div>
                            <div className="control search connections">
                                <SearchControl
                                    {...this.props}
                                    changeHandler={this.searchHandler}
                        			extraClasses=""
                        			placeholder="Search Connections"
                        			wrapperClass="header-control mobile"
                                    defaultFocus={false}
                                    fieldIcon="icon ion-search"/>
                            </div>
                        </div>
                    </Breakpoint>
                </div>
                {main}
            </div>
        );

        return (
            <Content header={null} main={content} modal={modal}/>
        );
    }
}

export default ComponentWithContext(Connections);
